import { removeToken, setToken, removeUsername, setUsername } from '@/utils/auth'
import { login, getInfo } from '@/api/login'
import store from '@/store'
import router from '@/router'
import qs from 'qs'

const user = {
  state: {
    userId: '',
    loginName: '',
    roles: [],
    pwd: '',
    ImgUrl: '',
    companies: [],
    permissions: []
  },
  mutations: {
    SET_USER: (state, userInfo) => {
      state.userName = userInfo.user.userName
      state.userId = userInfo.user.id
      state.loginName = userInfo.user.loginName
      state.pwd = userInfo.pwd
      state.ImgUrl = userInfo.user.pictureUrl
      state.roles = userInfo.roleList
      state.companies = userInfo.orgTree
      state.permissions = userInfo.funList
    },
    RESET_USER: (state) => {
      state.userId = ''
      state.loginName = ''
      state.pwd = ''
      state.ImgUrl = ''
      state.roles = []
      state.companies = []
      state.permissions = []
    }
  },
  actions: {
    // 登录
    Login({ commit, state }, loginForm) {
      return new Promise((resolve, reject) => {
        loginForm = qs.stringify(loginForm)
        login(loginForm).then(res => {
          if (res.code === 200) {
            // cookie中保存前端登录状态
            setToken()
            const token = res.data.tokenHead + res.data.token
            sessionStorage.setItem('token', JSON.stringify(token))
            sessionStorage.setItem('refreshToken', JSON.stringify(res.data.refreshToken))
          }
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          refreshToken()
          setInterval(() => {
            refreshToken()
          }, 1800000)
          // 储存用户信息
          commit('SET_USER', res.data)
          // cookie保存登录状态,仅靠vuex保存的话,页面刷新就会丢失登录状态
          setToken()
          // cookie 存放当前的登录的账号
          setUsername()
          // 生成路由
          const userMenuTree = res.data.funTree
          store.dispatch('GenerateRoutes', userMenuTree).then(() => {
            // 生成该用户的新路由json操作完毕之后,调用vue-router的动态新增路由方法,将新路由添加
            router.addRoutes(store.getters.addRouters)
          })

          resolve(res.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    LogOut({ commit }) {
      sessionStorage.removeItem('token')
      return new Promise(resolve => {
        commit('RESET_USER')
        removeToken()
        removeUsername()
        resolve()
      })
    },
    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('RESET_USER')
        removeToken()
        removeUsername()
        resolve()
      })
    }
  }
}
// token过期，重新获取token
function refreshToken() {
  let postData = {
    grant_type: 'refresh_token',
    client_id: 'client-app',
    client_secret: '123456',
    refresh_token: JSON.parse(sessionStorage.getItem('refreshToken'))
  }
  postData = qs.stringify(postData)
  login(postData).then(res => {
    if (res.code === 200) {
      // cookie中保存前端登录状态
      setToken()
      const token = res.data.tokenHead + res.data.token
      sessionStorage.setItem('token', JSON.stringify(token))
      sessionStorage.setItem('refreshToken', JSON.stringify(res.data.refreshToken))
    }
  })
}
export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js